import { render, staticRenderFns } from "./RewardManager.vue?vue&type=template&id=473ba59e&scoped=true&"
import script from "./RewardManager.vue?vue&type=script&lang=js&"
export * from "./RewardManager.vue?vue&type=script&lang=js&"
import style0 from "./RewardManager.vue?vue&type=style&index=0&id=473ba59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ba59e",
  null
  
)

export default component.exports